import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow } from 'material-ui';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FlagComplianceRow from './FlagComplianceRow';

export const styles = {
    flag: {
        width: '15%',
        whiteSpace: 'break-spaces',
    },
    riskFactor: {
        width: '10%',
    },
    avoid: {
        width: '65%',
    },
    controls: {
        display: 'flex', 
        margin: 'auto',
    },
};

function FlagComplianceTable({ flagComplianceList }) {
    const [rows, setRows] = useState([]);

    const handleUpdateRow = () => {
        setRows(flagComplianceList);
    };

    useEffect(() => {
        handleUpdateRow();
    }, [flagComplianceList]);

    return (
        <div>
            <div className='table-body'>
                <Table 
                    selectable={false}
                >
                    <TableHeader
                        displaySelectAll={false}
                        adjustForCheckbox={false}
                    >
                        <TableRow>
                            <TableHeaderColumn style={styles.flag} >
                                Flag
                            </TableHeaderColumn>
                            <TableHeaderColumn style={styles.riskFactor}>
                                Risk Factor
                            </TableHeaderColumn>
                            <TableHeaderColumn style={styles.avoid}>
                                Avoid countries
                            </TableHeaderColumn>
                            <TableHeaderColumn style={styles.controls}>
                                {null}
                            </TableHeaderColumn>
                        </TableRow>
                    </TableHeader>
                    <TableBody displayRowCheckbox={false}>
                        {
                            rows.map((item) => {
                                return (
                                    <FlagComplianceRow
                                        key={item._id}
                                        item={item}
                                    />
                                );
                            })
                        }
                    </TableBody>
                </Table>
            </div>
        </div>
    );
}

export default connect(
    (state) => {
        return {
            flagComplianceList: state.flagCompliance.items,
        };
    },
    dispatch => bindActionCreators(
        {},
        dispatch,
    ),
)(FlagComplianceTable);



// WEBPACK FOOTER //
// ./app/components/FlagCompliance/FlagComplianceTable.jsx